export default __webpack_public_path__ + "0edd5afe265fdd8dfed3a2333dae40f7.svg";